import React, { useState } from "react";

/// React router dom
import { Link } from "react-router-dom";

/// images
import logoText from "../../../images/logo-text.png";

import logo from "../../../images/logo-transparent.png";
import logoLong from "../../../images/logo-long.png";

const NavHader = () => {
   const [toggle, setToggle] = useState(false);
   return (
      <div className="nav-header">
         <Link to="/" className="brand-logo">
            <img className="logo-abbr" src={toggle?logo:logo} alt="" />
            {/* {toggle?<></>:<h5 className="mt-2" style={{color:"#3080B7"}}>RM Kishan Solar</h5>} */}
            
         </Link>

         <div className="nav-control" onClick={() => setToggle(!toggle)}>
            <div className={`hamburger ${toggle ? "is-active" : ""}`}>
               <span className="line"></span>
               <span className="line"></span>
               <span className="line"></span>
            </div>
         </div>
      </div>
   );
};

export default NavHader;
